import React, { Component } from 'react';
import PropTypes from 'prop-types';
import PastOrderItem from './PastOrderItem';

export default class PastOrders extends Component {
  constructor(props) {
    super(props);

    this.state = {
      selectedOrder: {},
    };
  }

  toggleSelectedOrder (newOrder) {
    if (newOrder.id === this.state.selectedOrder.id) {
      this.setState({ selectedOrder: {} });
      return;
    }

    this.setState({
      selectedOrder: newOrder,
    });
  }
  render = () => {
    const { pastOrders ,currentIndex, buttonLoading} = this.props;
    return (
      <div className="PastOrdersContainer">
        {pastOrders.map((order,index)=> {
          if (!order) {
            return (<div>details not found</div>);
          }
          return (<PastOrderItem
            key={order.id}
            buttonLoading={buttonLoading}
            orderDetails={order}
            index={index}
            currentIndex={currentIndex}
          />);
        })}
      </div>
    );
  }
}

PastOrders.propTypes = {
  pastOrders: PropTypes.array,
};

PastOrders.defaultProps = {
  pastOrders: [],
};
